import API from '../AxiosInstance';

export default {
  getAllTenants: function() {
    const options = {};
    return API.get('tenants', options);
  },
  updateTenant: function(payload) {
    const body = payload.formData;
    return API.patch('tenants/' + payload.id, body);
  },
  deleteTenant: function(id) {
    const options = {};
    return API.delete('tenants/' + id, options);
  },
  restoreTenant: function(payload) {
    const body = {};
    return API.patch(`tenants/${payload.nodeId}/restore`, body);
  },
  updateTenantSettings: function(nodeId, settings) {
    return API.post(`tenants/${nodeId}/settings`, settings);
  },
  refreshTenantSettings: function(nodeId) {
    return API.get(`/tenants/${nodeId}/settings`);
  },
  getVideoTranscodingResolutions: function(nodeId) {
    return API.get(`tenants/${nodeId}/video-transcoding-resolutions`);
  },
  updateVideoTranscodingResolutions: function(nodeId, enabledProfileIds) {
    return API.put(`tenants/${nodeId}/video-transcoding-resolutions`, { enabledProfileIds });
  },
  resetBandwidth: function(nodeId) {
    return API.post(`tenants/${nodeId}/resources/bandwidth/reset`);
  },
  /**
   * @param {{
   *   accessPointId: string,
   *   resource: string,
   *   quantity: number,
   * }} payload
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  purchaseResource: function(payload) {
    return API.post(`tenants/${payload.accessPointId}/resources/purchase`, {
      resource: payload.resource,
      quantity: payload.quantity,
    });
  },
  deleteOwnTenant: function(nodeId) {
    return API.delete(`/tenants/${nodeId}/delete`);
  },
  promoteOwner: function(nodeId, userId) {
    return API.patch(`tenants/${nodeId}/users/${userId}/promote`);
  }
}
